import * as React from "react"

import { cn } from "./cn"

/**
 * `compact` is the row height of a table or a toolbar (36px instead of 40px),
 * for a field that sits beside small buttons. A module asks for it here rather
 * than overriding the height, so the size stays the kit's to change.
 */
function Input({
  className,
  type,
  compact = false,
  ...props
}: React.ComponentProps<"input"> & { compact?: boolean }) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-10 w-full min-w-0 rounded-xl border border-input bg-background avex:rounded-avex-sm avex:border-line-control avex:bg-surface avex:shadow-none px-3 py-2 text-base shadow-sm transition-[color,box-shadow] outline-none file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 avex:focus-visible:border-ink avex:focus-visible:ring-surface-sunken",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20",
        compact && "h-9 px-2 avex:h-8",
        className
      )}
      {...props}
    />
  )
}

export { Input }
